import React from 'react';

interface Props {
  label:   string;
  value:   string | number;
  cls?:    string;
  icon?:   string;
  change?: string;
  trend?:  'up' | 'down' | 'neutral';
  accent?: string;
}

export const StatCard: React.FC<Props> = ({ label, value, cls = '', icon, change, trend, accent }) => (
  <div className="stat-card">
    {accent && <div className="stat-accent" style={{ background: accent }} />}
    {icon   && <div className="stat-icon">{icon}</div>}
    <div className="stat-label">{label}</div>
    <div className={`stat-value ${cls}`} style={String(value).length > 12 ? { fontSize: 16 } : undefined}>
      {value}
    </div>
    {change && (
      <div className={`stat-change ${trend === 'up' ? 'up' : trend === 'down' ? 'down' : ''}`}>
        {trend === 'up' ? '↑ ' : trend === 'down' ? '↓ ' : ''}{change}
      </div>
    )}
  </div>
);
